import { Container } from "react-bootstrap"
import { Route, Switch, useRouteMatch  } from "react-router-dom";

import DoctorPerfil from './doctor/DoctorPerfil';

import "../styles/doctores/perfilDoctor.css"

function PerfilDoctorIndex() {
    let { path, url } = useRouteMatch();

    return(
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><DoctorPerfil url={url}/></Route>
            </Switch>
        </Container>
    )
}

export default PerfilDoctorIndex